import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Polyfill Array.prototype.at for older environments (e.g. react-snap's bundled Chromium)
if (!Array.prototype.at) {
  // eslint-disable-next-line no-extend-native
  Array.prototype.at = function(n) {
    n = Math.trunc(n) || 0;
    if (n < 0) {
      n += this.length;
    }
    if (n < 0 || n >= this.length) {
      return undefined;
    }
    return this[n];
  };
}

// Remove portal artifacts (e.g. ant-notification containers) left in <body>
// by react-snap pre-rendering, so React doesn't create duplicates on mount.
document.querySelectorAll('.ant-notification, .ant-modal-root, .ant-drawer-root').forEach(el => el.remove());

const rootElement = document.getElementById('root');

// Detect whether the pre-rendered HTML actually belongs to the current URL.
// react-snap bakes the page's og:url into the <head> via react-helmet-async.
// If nginx fell back to index.html (the pre-rendered home page) for a route
// that was never pre-rendered (e.g. /blog), the og:url pathname won't match
// window.location.pathname — so we use createRoot instead of hydrateRoot.
const ogUrl = document.querySelector('meta[property="og:url"]')?.getAttribute('content');
const prerenderedPathname = ogUrl ? new URL(ogUrl, window.location.href).pathname : null;
const isPrerendered = rootElement.hasChildNodes() && prerenderedPathname === window.location.pathname;

if (!isPrerendered) {
  // Pre-rendered content belongs to a different route (nginx fell back to
  // the pre-rendered home page for a route like /blog). Clear it and remove
  // the visibility:hidden style injected by the head script above.
  rootElement.innerHTML = '';
  document.getElementById('route-mismatch-hide')?.remove();
}

if (isPrerendered) {
  hydrateRoot(rootElement, <App />);
} else {
  createRoot(rootElement).render(<App />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
